module.exports = __webpack_public_path__ + "static/sport/bgi-mb.82e3807.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/bgi-mb.jpg
// module id = Uk0L
// module chunks = 0